export const HIDE_COOKIES_NOTIFICATION_COOKIE_NAME = 'hideCookiesNotification';

export enum CookiesNotificationStatus {
  hide = 'true',
}
